define(
  'app/views/newsletter_vendor_view',['app/setup', 'app/views/newsletter_view'],
  function(takhfifan, newsletterView) {

  takhfifan.VendorNewsletterView = takhfifan.NewsletterView.extend({

    events: {
      'click button': 'submit',
      'submit': 'submit',
      'click li': 'setCity'
    },

    initialize: function(options) {
      this.model.on('newsletter:loading', this.loading, this);
      this.model.on('submit:success', this.success, this);
      this.model.on('submit:invalid', this.renderErrors, this);
      Backbone.Validation.bind(this);
      this.render();
    },

    loading: function() {
      this.$('.icon-warning').remove();
      this.$('button').html('<span class="spinner"></span>');
    },

    success: function() {
      //this.$('.error').empty().hide();
      this.$('.icon-warning').remove();
      this.$('button').empty().addClass('success').html('<span class="icon-check"></span>');
      setTimeout(function(){
        this.$('button').removeClass('success').html('اشتراک');
      }, 2500);
      this.$('input[name=email]').val('');
      takhfifan.eventHub.trigger('headernewsletter:subscribe');
    }

  });
});

